<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <HeadlineContainer :headline="page.attributes.title" :breadcrumbs="breadcrumbs"/>

      <div class="container">
        <div class="row">
          <div class="col-xs-6">
            <HelpText>
              <h3>
                Create Block
              </h3>

              <p>
                You can use this form to create a new block on the page.
              </p>
            </HelpText>
          </div>

          <div class="col-xs-18">
            <FormPanel :portal="portal" :block-types="blockTypes" :errors="errors" @submit="submit"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import FormPanel from '@/components/Panels/Administration/MarketingSites/Blocks/Form'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'

export default {
  components: {FormPanel, HeadlineContainer, HelpText, LoadingContainer},

  mixins: [Errors],

  props: {
    portalId: {
      required: true
    },

    pageId: {
      required: true
    }
  },

  data() {
    return {
      portal: null,
      page: null,
      blockTypes: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/marketing-sites', text: 'Marketing Sites'},
        {url: '/marketing-sites/' + this.portal.id, text: this.portal.attributes.name},
        {
          url: '/marketing-sites/' + this.portal.id + '/pages/' + this.page.id,
          text: this.page.attributes.title
        },
        {text: 'Create Block'},
      ]
    }
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portals/' + this.portalId),
        http.get('/api/v2/marketing-site-pages/' + this.pageId),
        http.get('/api/v2/marketing-site-block-types')
      ])
          .then(responses => {
            this.portal = responses[0].data.data

            this.page = responses[1].data.data

            this.blockTypes = responses[2].data.data

            this.loading = false
          })
    },

    submit(data) {
      http.post('/api/v2/marketing-site-blocks', {
        ...data,
        marketing_site_page_id: this.page.id,
      })
          .then(() => {
            notify.success('The block was saved')

            this.$router.push('/marketing-sites/' + this.portal.id + '/pages/' + this.page.id)
          }).catch(this.catchValidationErrors)
    }
  }
}
</script>
